export default __webpack_public_path__ + "static/media/coin.a06d4f0f.svg";